import React from 'react'

import ReactModal from 'react-modal'
import WrapIcon from '../../elements/WrapIcon'
import IconClose from '../../../assets/icons/IconClose'
import DynamicColor from '../dynamic-color'
import { COLOR_NAME } from '../../../constants'
ReactModal.setAppElement('#root')

const ModalForm = ({
    rootClass = '',
    containerClass = '',
    contentClass = '',
    children,
    className = '',
    centered,
    onClose,
    contentStyles,
    btnCloseStyles,
    ...props
}) => {
    const rootClasses = ['app-modal', rootClass].join(' ')
    const containerClasses = [
        'modal-container',
        centered ? 'centered' : '',
        containerClass,
    ].join(' ')
    const contentClasses = ['modal-content', contentClass].join(' ')

    return (
        <ReactModal
            overlayClassName="app-react-modal__overlay"
            className={rootClasses}
            {...props}
        >
            <div className={containerClasses}>
                <DynamicColor
                    style={{
                        backgroundColor: COLOR_NAME.MODAL_BG,
                        ...contentStyles,
                    }}
                    className={contentClasses}
                >
                    {onClose && (
                        <div className="btn-close" onClick={onClose}>
                            <WrapIcon
                                icon={IconClose}
                                size="20px"
                                color="000000"
                                {...btnCloseStyles}
                            />
                        </div>
                    )}
                    {children}
                </DynamicColor>
            </div>
        </ReactModal>
    )
}

export default ModalForm
